import { FilterType } from '../../../../../models/Filter';

export const FORM_FIELD_NAMES = {
  tags: 'tags',
  region: 'region',
  sector: 'sector',
  subsector: 'subsector',
  topic: 'topic',
  creditGrade: 'creditGrade',
  error: 'error',
  category: 'category',
  report: 'report',
  analyst: 'analyst',
  assetClass: 'assetClass',
} as const;

export const FORM_HEADER_TITLES = {
  addPreferences: 'Add Interests',
  editPreferences: 'Edit Interests',
};

export const SUB_SECTOR_PLACEHOLDERS = {
  sectorSelected: 'Select Subsector',
  sectorNotSelected: 'Select Sector to Populate',
};

export const FORM_CATEGORY_VALUES = {
  Interests: { text: 'Interests', value: 'interests' },
  Reports: { text: 'Reports', value: 'reports' },
  Analysts: { text: 'Analysts', value: 'analysts' },
};

export const REQUIRED_FILTERS = [
  FilterType.region,
  FilterType.sector,
  FilterType.topic,
  FilterType.assetClass,
  FilterType.creditGrade,
  FilterType.report,
];

export const DUPLICATE_PREFERENCES_ERROR_MESSAGE =
  'You have already added the selected preferences. Update your selections to create a new area of preference.';

export const MAXIMUM_PREFERENCES = 200;
